import { type fabric } from 'fabric';
import ControlBase from '../fabric/ControlBase';
import { renderAddControl } from './controlRendering';
import type Wireframe from '../objects/Wireframe';
import { ToolWireframeAddItem } from '../tools/wireframes/ToolWireframeAddItem';

const SIZE = 22;
const OFFSET = 27;

class WireframeAddItemControl extends ControlBase {
  // Name of the action the control is used for.
  actionName: string;
  // Whether the component items are in a row or column
  layout: 'row' | 'column';

  constructor({ layout = 'row' }: { layout?: 'row' | 'column' }) {
    super({});
    this.layout = layout;
    const isRow = layout === 'row';
    this.actionName = `Add item`;
    this.x = isRow ? 0.5 : 0;
    this.y = isRow ? 0 : 0.5;
    this.offsetX = isRow ? OFFSET : 0;
    this.offsetY = isRow ? 0 : OFFSET;
    this.sizeX = this.touchSizeX = this.sizeY = this.touchSizeY = SIZE;
    this.cursorStyle = 'pointer';
  }

  getMouseUpHandler(): fabric.ControlMouseEventHandler {
    return (eventData, transformData) => {
      const object = transformData.target as Wireframe;
      ToolWireframeAddItem.action({
        selection: object,
        controller: object.controller,
      });
      return true;
    };
  }

  render(ctx, left, top, styleOverride, fabricObject) {
    renderAddControl.call(
      this,
      ctx,
      left,
      top,
      styleOverride,
      fabricObject,
      SIZE
    );
  }
}
export default WireframeAddItemControl;
